import { ConferencePromo } from '@fs/zion-rootstech'

const CalendarItemDetail = `
  ${ConferencePromo}
  fragment CalendarItemDetail on CalendarItemDetail {
    date
    item {
      ...ConferencePromo
    }
  }
`
export default CalendarItemDetail
